(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-products"] && !Shopify.designMode) return;
  try {
    (function(r,e,o){
  var w=window,d=document,t,s,x;
  w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
  t('init', {storeKey: r, environment: e, ...o});
  x=d.getElementsByTagName('script')[0];
  s=d.createElement('script');
  s.type='text/javascript';s.async=true;
  s.src = 'https://cdn.truefitcorp.com/fitrec/global/js/tf-integration.js?storeKey=' + r;
  x.parentNode.insertBefore(s,x);
// Don't change anything above this line
})('jow', 'prod', {autoCalculate: true});

function tfSizeSampling() {
    const CART_INFO = [];
  
    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cart) => {
        console.log('TF - cart result:', cart);
        cart.items.forEach((item) => {
          const sizePosition = item.options_with_values.findIndex((i) => i.name.toLowerCase().includes('size'));
          if (sizePosition !== -1) {
            CART_INFO.push({
              styleId: item.product_id.toString(),
              styleName: item.product_title,
              size: item.variant_options[sizePosition]
            });
          }
        });
        console.log('calling tf sizeSampling with cart info:', CART_INFO);
      tfcapi('sizeSampling', CART_INFO);
      });
  }
  
  const drawer = document.querySelector(".cart-drawer__dialog");
    if (drawer) {
      const observer = new MutationObserver(() => {
        if (drawer.hasAttribute("open")) {
          tfSizeSampling();
        }
      });

      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ["open"],
      });
    }
  } catch(e) { console.error(e); }
})();

})();
